import { addressesStore, setAddresses, addNewAddress, updateAddress } from "../stores/addresses";
import { userStore, setUser } from "../stores/user";
import { getUser as apiGetUser, updateUser as apiUpdateUser } from "../apiLoader/user";
import { createAddress as apiCreateAddress, updateAddress as apiUpdateAddress } from "../apiLoader/address";
import type { Address } from "../api/address";
import type { UserDataInput } from "../api/user";
import { get } from "svelte/store";
import { processUserData } from "./userData";

const getAndSaveUserAndAddresses = async () => {
  const user = await apiGetUser();

  if (user) {
    const userData = processUserData(user);

    setUser(userData);
    setAddresses(user.addresses || []);
  }
};

export const getUser = async () => {
  if (!get(userStore).hasLoaded) {
    await getAndSaveUserAndAddresses();
  }

  return get(userStore).user;
};

export const getAddresses = async () => {
  if (!get(addressesStore).hasLoaded) {
    await getAndSaveUserAndAddresses();
  }

  return get(addressesStore).addresses;
};

export const createOrUpdateAddress = async (address: Address) => {
  const backendAction = address?.id ? apiUpdateAddress : apiCreateAddress;
  const storeAction = address?.id ? updateAddress : addNewAddress;

  const response = await backendAction(address);
  storeAction(response.address);
};

export const updateUser = async (user: UserDataInput) => {
  await apiUpdateUser(user);
  setUser(user);
};
